const AEC_DOWNLOAD = [
    {
        sectionID: 'aecDownload',
        sectionName: '',
        fieldList: [
            {
                id: 'download',
                label: '',
                type: 'tableDownload',
                rule: { disabled: true },
                subFields: [
                    {
                        id: 'file-name',
                        header: 'File Name',
                        type: 'dateTime',
                        rule: { disabled: true }
                    },
                    {
                        id: 'category',
                        header: 'Category',
                        type: 'dateTime',
                        rule: { disabled: true }
                    },
                    {
                        id: 'download',
                        header: 'Download',
                        type: 'dateTime',
                        rule: { disabled: true }
                    }
                ],
                span: 12
            }
        ]
    }
];

export default AEC_DOWNLOAD;
